var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComponent32(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.04297,
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#paint0_linear_3545_22143)",
    stroke: "url(#paint1_linear_3545_22143)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3545_22143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53027 5.87183L5.77295 7.1145L8.87964 4.00781",
    stroke: "white",
    strokeWidth: 1.0608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3545_22143",
    x1: 1.5,
    y1: 7.16797,
    x2: 10.875,
    y2: 7.35547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8156EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449243,
    stopColor: "#487DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3545_22143",
    x1: 1.5,
    y1: 7.16797,
    x2: 10.875,
    y2: 7.35547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8156EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449243,
    stopColor: "#487DED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AFEF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3545_22143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.41017,
    height: 5.22829,
    fill: "white",
    transform: "translate(4 2.94727)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent32);
export default __webpack_public_path__ + "static/media/Component 32.ec37038b08e27b555d4bc070269e0ec4.svg";
export { ForwardRef as ReactComponent };